module.exports = __webpack_public_path__ + "img/dislike.dd840954.svg";